/* eslint-disable ember/no-computed-properties-in-native-classes */
import EmberObject, { computed } from '@ember/object';

import PowerDetails from './power-details';
import FilterConstants from '../../../filter-constants';

export default class PowerResults extends EmberObject {
  componentsInput = null; // input/component-selection
  stages = null; // stages/actual-stage array
  needReferenceStage = null; // boolean
  @computed('componentsInput') get powerSupply() {
    var vsMinus = this.componentsInput.vsMinus;
    var vsPlus = this.componentsInput.vsPlus;
    var result = Math.abs(vsMinus) + Math.abs(vsPlus);
    return result;
  }

  @computed('stages', 'powerSupply') get detailsOfPower() {
    var stages = this.stages;
    var powerSupply = this.powerSupply;
    var result = stages.map((stage) => {
      return PowerDetails.create({ stage: stage, powerSupply: powerSupply });
    });

    return result;
  }

  @computed('needReferenceStage', 'powerSupply') get referenceStage() {
    var result = null;
    var needReferenceStage = this.needReferenceStage;
    if (needReferenceStage) {
      var powerSupply = this.powerSupply;
      var supplyCurrent = FilterConstants.Limits.REFERENCE_OPAMP_CURRENT;
      var resistorCurrent = powerSupply / (2 * FilterConstants.Limits.REFERENCE_RESISTOR);
      var power = powerSupply * (supplyCurrent + resistorCurrent);
      result = EmberObject.create({
        powerSupply: powerSupply,
        inputSupplyCurrent: supplyCurrent,
        resistorCurrent: resistorCurrent,
        power: power,
      });
    }

    return result;
  }

  @computed('detailsOfPower', 'referenceStage') get totalSupplyCurrents() {
    var detailsOfPower = this.detailsOfPower;
    var referenceStage = this.referenceStage;
    var inputSupplyCurrents = detailsOfPower.map((item) => {
      return item.inputSupplyCurrent;
    });
    var result = 0;

    inputSupplyCurrents.forEach((element) => {
      result += element;
    });

    if (referenceStage) {
      result = result + referenceStage.inputSupplyCurrent + referenceStage.resistorCurrent;
    }

    return result;
  }

  @computed('totalSupplyCurrents', 'powerSupply') get totalPowerConsumption() {
    var totalSupplyCurrents = this.totalSupplyCurrents;
    var powerSupply = this.powerSupply;
    var result = totalSupplyCurrents * powerSupply;
    return result;
  }
}
